import { settings } from 'config';
import { setItemToStore } from 'helpers/utils';
//import { useNavigate } from 'react-router-dom';


export const configReducer = (state, action) => {

  //const navigate = useNavigate();

  const { type, payload } = action;
  switch (type) {
    case 'SET_CONFIG':
      if (payload.setInStore) {
        setItemToStore(payload.key, payload.value);
      }
      return {
        ...state,
        [payload.key]: payload.value
      };
    case 'REFRESH':
      return {
        ...state
      };
    case 'RESET':
      //localStorage.clear();
  //navigate('/authentication/simple/login');
      return {
        ...state,
        ...settings
      };
    default:
      return state;
  }
};
